<template>
    <q-dialog v-model="show" position="bottom"> 
        <q-card class="bg-yellow-2" dense flat>
            <q-card-section class="q-pa-none q-ma-none">
                <q-item bordered>
                    <q-item-section avatar>
                        <q-avatar size="80px">
                            <q-icon name="img:/assets/icons/qplus.svg" />
                        </q-avatar>
                    </q-item-section>
                    <q-item-section>
                        <q-item-label class="text-center q-pa-none q-ma-none">
                            <div class="text-h6 text-bold">Make it easier <q-icon color="secondary" name="img:/assets/icons/hand.svg" /></div>
                        </q-item-label>
                        <q-item-label class="text-center q-pa-none q-ma-none">
                            <a
                                ref="addBtn"
                                class="add-button text-primary"
                                @click="install" 
                            >Add to home screen </a>
                        </q-item-label>
                    </q-item-section>

                    <q-item-section side class="text-center">
                        <q-btn dense rounded color="accent" size="xs" @click="dismiss" dark icon="close" v-close-popup>
                            <q-tooltip class="bg-white text-primary">Close</q-tooltip>
                        </q-btn>
                    </q-item-section>
                </q-item>
            </q-card-section>
        </q-card>
    </q-dialog>
</template>

<script>
import { ref } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core'
export default {
    props: ['show'],
    setup(props, context) {
        const deferredPrompt = ref(null)

        window.addEventListener('beforeinstallprompt', (e) => {
            // ! Prevent Chrome 67 and earlier from automatically showing the prompt
            e.preventDefault()
            // Stash the event so it can be triggered later.
            deferredPrompt.value = e
        })
        window.addEventListener("appinstalled", () => {
            dismiss()
            context.emit('added-home', choiceResult.outcome === 'accepted')
        });

        const install = () => {
            // Show the prompt
            deferredPrompt.value.prompt()
        }

        const dismiss = () => {
            deferredPrompt.value = null
        }

        return {install, dismiss}
    },
}
</script>
